import { Mail } from 'lucide-react';
import { EmptyState } from './shared';

export function ContactsTab({ contacts }) {
  if (contacts.length === 0) return <EmptyState icon={Mail} text="Aucun message de contact" />;

  return (
    <div className="space-y-3">
      {contacts.map((c) => (
        <div key={c.id} className="bg-white dark:bg-neutral-800 rounded-lg border dark:border-neutral-700 p-4" data-testid={`contact-${c.id}`}>
          <div className="flex items-center justify-between mb-2">
            <p className="font-medium text-sm dark:text-white">{c.name} &middot; <span className="text-neutral-500">{c.email}</span></p>
            <p className="text-xs text-neutral-400">{new Date(c.created_at).toLocaleDateString('fr-FR')}</p>
          </div>
          <p className="text-sm font-medium text-neutral-900 dark:text-neutral-100 mb-1">{c.subject}</p>
          <p className="text-sm text-neutral-600 dark:text-neutral-400">{c.message}</p>
        </div>
      ))}
    </div>
  );
}
